module.exports = __webpack_public_path__ + "static/media/keepsporting-top.09c5daf4.png";